import ContentLoader from "../contentLoader/contentLoader.jsx";

const SkeletonLoaderWrapper = (props) => {
	const { loading } = props
	return !loading ? (
		<>{props.children}</>
	) : (
		<ContentLoader loading={loading}/>
	)
};

export default SkeletonLoaderWrapper